<template>
  <div>
    <TablePublic
        :colLists="weightDetailColLists"
        :tableData="data"
        :paginationFlag="false"
        summary
        :summary-method="weightDetailSummaryMethod"
      >
      </TablePublic>
  </div>
</template>
<script>
import TablePublic from '@/components/tablePublic.vue'
export default {
  name: "WeightDetail",
  components: {
    TablePublic,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      weightDetailColLists: [
        {
          prop: 'netWeight',
          label: '实际总净重（斤）',
          isTrue: true,
        },
      ],
    }
  },
  methods: {
    weightDetailSummaryMethod(param) {
      const { columns, data } = param
      const sums = []
      console.log(columns, data, '---')

      if (!data) return sums

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 0) {
          sums[index] = '合计'
          return
        }

        if (index == 1) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (Number(cur.netWeight) || 0), 2)
          }, 0)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
  }
}
</script>